import React from "react";

export const ScrollContainerRefContext =
  React.createContext<React.RefObject<HTMLDivElement> | null>(null);
